import { useContext } from 'react';
import StyledTasksButton from './StyledTasksButton';
import TasksIconButton from './TasksIconButton';
import { Tooltip, useMediaQuery } from '@mui/material';
import { ViewColumnOutlined as TasksIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import ChallengeContext from '../../ChallengeContext';
import type React from 'react';

type TasksButtonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const TasksButton = ({ onClick }: TasksButtonProps) => {
  const [challenge] = useContext(ChallengeContext);

  const shouldUseShortLabel = useMediaQuery('(max-width: 1024px)');
  const shouldUseIconButton = useMediaQuery('(max-width: 880px)');

  const taskCount = Object.keys(challenge.tasks).length;

  if (shouldUseIconButton) {
    return (
      <Tooltip
        title={
          <FormattedMessage
            id="portfolio.challenge.tasks_button"
            values={{
              taskCount,
            }}
          />
        }
      >
        <TasksIconButton onClick={onClick}>
          <TasksIcon />
        </TasksIconButton>
      </Tooltip>
    );
  }

  return (
    <StyledTasksButton startIcon={<TasksIcon />} onClick={onClick}>
      <FormattedMessage
        id={
          shouldUseShortLabel
            ? 'portfolio.challenge.tasks_button.short'
            : 'portfolio.challenge.tasks_button'
        }
        values={{
          taskCount,
        }}
      />
    </StyledTasksButton>
  );
};

export default TasksButton;
